import { render, staticRenderFns } from "./attachments.vue?vue&type=template&id=ea9aa26e&scoped=true"
import script from "./attachments.vue?vue&type=script&lang=js"
export * from "./attachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9aa26e",
  null
  
)

export default component.exports